export const translateCliniciansToOptions = (clinicians) => {
  return clinicians.map((clinician) => {
    return {
      value: clinician.clinician_id,
      label: clinician.first_name + ' ' + clinician.last_name,
    };
  });
};
